import styled, {CSSProperties} from 'styled-components';
import {interceptProps} from '@/styled-components';

export const SideElementWrapper = styled('div').withConfig({
  shouldForwardProp: interceptProps(['justifyContent']),
})<{
  justifyContent?: CSSProperties['justifyContent'];
}>`
  width: 112px;
  display: flex;
  ${({justifyContent}) =>
    justifyContent && `justify-content: ${justifyContent};`};
`;
